import { api } from './client';
import type { VersionSettings, VersionUpdateRequest } from './types';

export function getVersionSettings() {
  return api.get<VersionSettings>('/api/admin/version');
}

export function updateVersionSettings(data: VersionUpdateRequest) {
  return api.put<VersionSettings>('/api/admin/version', data);
}
